import { createContext } from 'react'

type BtokPlatformValue = 'IOS_H5' | 'ANDROID_H5' | 'GOOGLE_H5'

interface GlobalContextType {
  username: string
  platform: BtokPlatformValue
  language: string // 'zh'
  tgid: string
  parentTGID?: string
}

export const GlobalContext = createContext<GlobalContextType | undefined>(undefined)
